import { AmpersandTop } from './AmpersandTop';

export default AmpersandTop;
